import SectionHeading from "@/pages/home/components/SectionHeading";
import { quickEntries } from "@/mocks/home";

const toneStyles: Record<string, { icon: string; link: string }> = {
  primary: {
    icon: "bg-primary-100 text-primary-700",
    link: "text-primary-700 group-hover:text-primary-600",
  },
  accent: {
    icon: "bg-accent-100 text-accent-700",
    link: "text-accent-700 group-hover:text-accent-600",
  },
  secondary: {
    icon: "bg-secondary-100 text-secondary-700",
    link: "text-secondary-700 group-hover:text-secondary-600",
  },
};

export default function QuickEntrySection() {
  return (
    <section id="quick-entry" className="scroll-mt-28 py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <SectionHeading
          eyebrow="快速入口"
          title="想做什么？从这里直接出发"
          desc="把最常需要的几步做成入口卡片，点一下就能跳到对应说明，不用在页面里反复找。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {quickEntries.map((entry) => {
            const tone = toneStyles[entry.tone] ?? toneStyles.primary;
            return (
              <div
                key={entry.id}
                className="group flex flex-col p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
              >
                <span className={`w-11 h-11 rounded-md flex items-center justify-center ${tone.icon}`}>
                  <i className={`${entry.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">
                  {entry.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{entry.desc}</p>
                <a
                  href={entry.target}
                  className={`mt-4 inline-flex items-center gap-1.5 text-sm font-medium transition-colors cursor-pointer ${tone.link}`}
                >
                  {entry.actionLabel}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}